import { render, staticRenderFns } from "./ProjectSelectListItem.vue?vue&type=template&id=1bbc1c3c&scoped=true&"
import script from "./ProjectSelectListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectSelectListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSelectListItem.vue?vue&type=style&index=0&id=1bbc1c3c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbc1c3c",
  null
  
)

export default component.exports